<template>
  <div
    class="folder"
    :class="[isSelected && 'folder--selected']"
    @click="$emit('click',{'id':$event.target.id})"
  >
    <v-icon
      class="folder__icon"
      type="folder"
    />
    <span class="folder__title">
      {{ title }}
      <span
        v-if="subtitle"
        class="folder__subtitle"
      >{{ subtitle }}</span>
    </span>
    <v-dropdown
      v-if="hasMenu()"
      is-right
    >
      <v-icon type="ellipsis-v" />
      <template #dropdown-menu>
        <slot name="menu" />
      </template>
    </v-dropdown>
  </div>
</template>

<script>
  import Icon from "@/atoms/Icon";
  import Dropdown from "@/molecules/Dropdown";

  export default {
    components: {
      "v-icon": Icon,
      "v-dropdown": Dropdown,
    },
    props: {
      title: {
        type: String,
        default: null,
        required: true
      },
      subtitle: {
        type: String,
        default: null
      },
      isSelected: {
        type: Boolean,
        default: false
      }
    },
    methods :{
      hasMenu() {
        return !!this.$slots.menu
      }
    }
  };
</script>

<style lang="scss">
  @import "../../styles/shared/shared";

  .folder {
    $this: &;
    display: flex;
    padding: $card-padding-y $card-padding-x;
    border-bottom: solid 1px $zircon;
    align-items: center;
    transition: .15s;
    cursor: pointer;  
    &__icon {
      font-size: 1.5em;
      align-self: flex-start;
      margin-right: .5rem;
      color: $azure;
    }
    &__title {
      flex: 1;
      font-weight: bold;
      margin-right: 1rem;
      color: $tangaroa;
    }
    &__actions {
      display: flex;
    }
    &:hover {
      background-color: $zircon;
    }
    &--selected {
      &,
      &:hover {
        border-bottom-color: $azure;
        background-color: $azure;  
        cursor: default;
      }
      #{$this}__title,
      #{$this}__icon {
        color: $white;
      }
    }
  }
</style>
